import React from 'react';
import { FC } from 'react';
import styled from 'styled-components';

const _lowVisionSolid: FC<{ className?: string }> = () => (
    <svg xmlns='http://www.w3.org/2000/svg' width='28' height='28' viewBox='0 0 28 28' fill='none'>
        <g clipPath='url(#clip0_748_7180)'>
            <path
                d='M1.71875 0.28125L0.28125 1.71875L26.2812 27.7188L27.7188 26.2812L21.125 19.6875C24.4375 17.6211 26.6367 14.9023 26.7812 14.7188L27 14.4375V13.5312L26.75 13.25C26.4961 12.9531 20.5234 6 14 6C12.0977 6 10.3203 6.53125 8.71875 7.28125L1.71875 0.28125ZM14 8C18.6484 8 23.2812 12.4805 24.75 14.0312C23.9375 14.9492 22.0977 16.832 19.6875 18.25L17.4375 16C18.3359 14.4688 18.1289 12.4727 16.8125 11.1562C15.4961 9.83984 13.5312 9.66406 12 10.5625L10.25 8.8125C11.4336 8.33594 12.6836 8 14 8ZM5.75 9.03125C3.07031 10.957 1.34766 13.1211 1.21875 13.2812L1 13.5312V14.4688L1.25 14.75C1.51172 15.0469 7.71875 22 14 22C15.3984 22 16.75 21.7266 18 21.2812L5.75 9.03125ZM6.375 11.0938L15.1875 19.9062C14.8008 19.9609 14.3984 20 14 20C13.5156 20 13.0195 19.9414 12.5312 19.8438L4.96875 12.25C5.38281 11.8711 5.86328 11.4883 6.375 11.0938ZM4.21875 12.9375L10.5312 19.2188C7.28906 17.8672 4.37891 15.1211 3.25 13.9688C3.48438 13.7031 3.82031 13.332 4.21875 12.9375Z'
                fill='#445A64'
            />
        </g>
        <defs>
            <clipPath id='clip0_748_7180'>
                <rect width='28' height='28' fill='white' />
            </clipPath>
        </defs>
    </svg>
);

const LowVisionSolid = styled(_lowVisionSolid)``;

export default LowVisionSolid;
